import AccountabilityDefinitionForm from './AccountabilityDefinitionForm';

export default function CreateAccountabilityDefinitionPage() {
  return <AccountabilityDefinitionForm />;
}
